module.exports = __webpack_public_path__ + "img/topic.4dd0bcea.svg";